import { motion } from "framer-motion";
import { useContent } from "@/i18n/content";
import { useI18n } from "@/i18n";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function WhyEWS() {
  const { PILLARS } = useContent();
  const { t } = useI18n();
  return (
    <section id="why" className="relative bg-[#FBFAF8] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-16 max-w-2xl">
          <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-emerald-600 font-semibold">
            {t("why.eyebrow")}
          </span>
          <h2 className="mt-4 font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#0B0F14] leading-[1.05]">
            {t("why.title")}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-slate-200 border border-slate-200 rounded-3xl overflow-hidden">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.num}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              className="relative bg-[#FBFAF8] p-8 sm:p-12 hover:bg-slate-50 transition-colors group"
            >
              <div className="flex items-start gap-6">
                <span className="font-display font-extrabold text-5xl sm:text-6xl text-slate-200 group-hover:text-emerald-600/40 transition-colors leading-none">
                  {p.num}
                </span>
                <div>
                  <h3 className="font-display font-bold text-xl sm:text-2xl text-[#0B0F14] mb-3 group-hover:text-emerald-600 transition-colors">
                    {p.title}
                  </h3>
                  <p className="text-slate-600 text-sm sm:text-base leading-relaxed">{p.desc}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
